import * as React from 'react'

import { cn } from '~/styled'

import { Badge } from '../badge/Badge'
import { SegmentedControlContext } from './SegmentedControlContext'

const badgeSizeMap = {
  sm: 'xs',
  md: 'xs',
  lg: 'sm'
}

export const SegmentedControlBadge = ({
  className,
  ...props
}: Omit<React.ComponentProps<typeof Badge>, 'size'>): React.JSX.Element => {
  const { size } = React.useContext(SegmentedControlContext)

  return (
    <Badge
      {...props}
      size={badgeSizeMap[size as string]}
      className={cn('border-none', 'font-normal', className)}
    />
  )
}
